import { motion } from 'framer-motion'
import { BoatIndicator } from '../ui/BoatIndicator'
import type { RaceParticipant } from '../../types'

interface StandingsOverlayProps {
  participants: RaceParticipant[]
  compact?: boolean
}

export function StandingsOverlay({
  participants,
  compact = true,
}: StandingsOverlayProps) {
  const displayParticipants = compact
    ? participants.slice(0, 5)
    : participants.slice(0, 10)

  return (
    <div className="min-h-screen bg-transparent flex flex-col justify-start p-4">
      <motion.div
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-palm-dark bg-opacity-80 backdrop-blur-md rounded-lg p-4 border border-tropical-green border-opacity-50 w-full max-w-2xl"
      >
        <h2 className="text-2xl font-fredoka font-700 text-tropical-green mb-4">
          STANDINGS
        </h2>

        <div className="space-y-2">
          {displayParticipants.map((participant, index) => (
            <motion.div
              key={participant.id}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.05 }}
              className="flex items-center gap-3 p-2 rounded-lg bg-palm-dark bg-opacity-50 border border-tropical-green border-opacity-20"
            >
              {/* Position */}
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-tropical-green text-palm-dark font-fredoka font-700 text-sm">
                {participant.current_position}
              </div>

              {/* Boat */}
              <BoatIndicator
                boatNumber={participant.boat_number}
                color={participant.boat_color}
                size="sm"
              />

              {/* Name */}
              <div className="flex-1">
                <div className="font-fredoka font-600 text-sand-light text-sm">
                  {participant.pilot_name}
                </div>
              </div>

              {/* Laps */}
              <div className="text-xs text-paradise-blue font-fredoka">
                {participant.total_laps}L
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </div>
  )
}
